interface Config {
  BACKEND_APP_BASE_URL: string | undefined;
  API_URL: string;
  APP_ENV: string;
  DEBUG_MODE: boolean;
  COUNTRY_CODE: string | undefined;
  CURRENCY: string | undefined;
  FILE_PATH: string | undefined;
  BRANCH_API_KEY: string | undefined;
  BRANCH_CLIENT_KEY: string | undefined;
  BOOKING_API_KEY: string | undefined;
  BOOKING_CLIENT_KEY: string | undefined;

  insuranceChargeCode: string[];
  ancilarriesChargeCode: string[];
}

export const config: Config = {
  insuranceChargeCode: ['WTP', 'SCDW', 'CDW', 'PAI', 'SDW', 'FCO'],
  ancilarriesChargeCode: ['COT', 'VRF', 'ADR'],
  BACKEND_APP_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  APP_ENV: process.env.REACT_APP_ENV || 'development',
  DEBUG_MODE: process.env.REACT_APP_DEBUG === 'true',

  BRANCH_API_KEY: process.env.REACT_APP_BRANCH_API_KEY || undefined,
  BRANCH_CLIENT_KEY: process.env.REACT_APP_BRANCH_API_CLIENT_KEY || undefined,

  BOOKING_API_KEY: process.env.REACT_APP_BOOKING_API_KEY || undefined,
  BOOKING_CLIENT_KEY: process.env.REACT_APP_BOOKING_CLIENT_KEY || undefined,

  COUNTRY_CODE: process.env.REACT_APP_API_COUNTRY_CODE || undefined,
  FILE_PATH: process.env.FILE_PATH || undefined,

  CURRENCY: 'AED',
};
